import { defineComponent as N, computed as l, openBlock as n, createBlock as s, Teleport as T, Transition as r, withCtx as i, withDirectives as d, createElementVNode as p, normalizeStyle as $, createVNode as E, mergeProps as v, withModifiers as b, renderSlot as y, vShow as u } from "vue";
import "./Modal.css";
const H = /* @__PURE__ */ N({
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    closeOnClickOverlay: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 },
    modalTransition: { default: "modal-slide" },
    transition: {},
    overlayStyle: {},
    position: { default: "bottom" },
    className: {}
  },
  emits: ["update:open", "OnClickOverlay", "after-show", "after-hide", "enter", "leave"],
  setup(h, { emit: k }) {
    const a = h, o = k, t = l({
      get() {
        return a.open;
      },
      set(e) {
        o("update:open", e);
      }
    }), c = l(() => {
      var e = [];
      return a.className && e.push(a.className), a.position && e.push("ap-modal-" + a.position), e.join(" ");
    }), m = l(() => a.transition ? a.transition : "modal-slide-" + a.position), C = (e) => {
      a.closeOnClickOverlay && (t.value = !1), o("OnClickOverlay");
    }, O = () => {
      o("after-show");
    }, w = () => {
      o("after-hide");
    }, S = () => {
      o("enter");
    }, B = () => {
      o("leave");
    };
    return (e, f) => (n(), s(T, { to: "body" }, [
      e.modal ? (n(), s(r, {
        key: 0,
        name: "modal-fade"
      }, {
        default: i(() => [
          d(p("div", {
            style: $(e.overlayStyle),
            class: "ap-overlay",
            onClick: C
          }, [
            E(r, {
              name: m.value,
              onAfterEnter: O,
              onAfterLeave: w,
              onEnter: S,
              onLeave: B
            }, {
              default: i(() => [
                d(p("div", v({ class: "ap-modal" }, e.$attrs, {
                  class: c.value,
                  onClick: f[0] || (f[0] = b(() => {
                  }, ["stop"]))
                }), [
                  y(e.$slots, "default")
                ], 16), [
                  [u, t.value]
                ])
              ]),
              _: 3
            }, 8, ["name"])
          ], 4), [
            [u, t.value]
          ])
        ]),
        _: 3
      })) : (n(), s(r, {
        key: 1,
        name: m.value
      }, {
        default: i(() => [
          d(p("div", v({ class: "ap-modal" }, e.$attrs, { class: c.value }), [
            y(e.$slots, "default")
          ], 16), [
            [u, t.value]
          ])
        ]),
        _: 3
      }, 8, ["name"]))
    ]));
  }
});
export {
  H as default
};
